import { DocumentClassAttributes, OrderAttributes, OrderDetailAttributes, OrderSubRouteAttributes, OrderTripAttributes, SubRouteAttributes, TripAttributes } from '@albatrosdeveloper/ave-models-package';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, signal, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { WeightFormatPipe } from 'app/pipes/weight-format.pipe';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { catchError, forkJoin, map, Observable, of, Subject, takeUntil } from 'rxjs';
import { LoadsService } from '../../loads.service';
import { OrdersListService } from '../../../../../sales/order-list-components/order-list.service';
import { calculateTotalWeight } from 'app/utils/weigth';
import { TripLoadData, TripMaterial } from '../../interfaces/trip-load-response.interface';
import { OrderDetailsTableComponent } from '../order-details-table/order-details-table.component';
import { SummaryMaterialComponent } from '../summary-material/summary-material.component';
import { OrderTableComponent } from '../order-table/order-table.component';
import { UnifiedTableComponent } from '../unified-table/unified-table.component';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { TimeDifferencePipe } from 'app/pipes/diference-time.pipe';
import { Router } from '@angular/router';
import { DocumentTypeEnum } from 'app/common/enums/document-types.enum';
import { IPagination, IPaginationResultFrequencies } from 'app/common/interfaces';
import { MapModalComponent } from 'app/shared/components/map-modal/map-modal.component';
import { MapModalInputData } from 'app/shared/components/map-modal/models/map-modal.interface';
import { MapFilterTypeEnum, MapModalTypeEnum, MonitorDocumentTypeEnum } from 'app/shared/components/map-modal/models/map-modal.enum';
import {
  TripVisitOrderDialog,
  TripVisitOrderDialogData,
} from '../trip-visit-order/trip-visit-order.dialog';
import { StatusEnum } from '@albatrosdeveloper/ave-models-package/lib/enums';
import { HandlerMessageService } from 'app/common/services/handler-error/handler-message.service';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { RefreshContext } from '../../interfaces/refresh-context.interface';
import { UnifiedLoadDocsChipComponent } from 'app/shared/components/unified-load-docs-chip/unified-load-docs-chip.component';

/**
 * Interface para el item seleccionado/expandido en la tabla de trips
 */
interface TripTableSelectedItem {
  id: string;
  trip: number;                       // tripId numeric
  tripMongoId: string;                // MongoDB ID para API calls
  route: {
    externalKeys: string;
    name: string;
    model: any;
    type: any;
  };
  tripDateHourEndTeoric: string;
  tripDateHourStartTeoric: string;
  tripDateHourStart: string | null;
  tripDateHourEnd: string | null;
  weight: number;                     // del backend
  orders: OrderAttributes[];          // órdenes del trip
  materialsSummary: TripMaterial[];   // del endpoint getMaterialsByTrip
  unifiedOrders: OrderAttributes[];
  tripId: number;                     // órdenes unificadas
}

@Component({
  selector: "app-trip-table",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    MatRadioModule,
    WeightFormatPipe,
    OrderDetailsTableComponent,
    NgxMaterialTimepickerModule,
    SummaryMaterialComponent,
    OrderTableComponent,
    UnifiedTableComponent,
    FormatOtherDateHourPipe,
    TimeDifferencePipe,
    UnifiedLoadDocsChipComponent,
  ],
  templateUrl: "./trip-table.component.html",
  styleUrl: "./trip-table.component.scss",
})
export class TripTableComponent implements OnInit, OnChanges {
  @Input() ordersData: TripLoadData[] | OrderAttributes[] = [];
  @Input() loadCalculationMode: string | undefined;
  @Input() UMPActive: boolean = false;
  @Input() useMap: boolean = true;
  @Input() documentClasses: DocumentClassAttributes[] = [];
  @Output() onSortChange: EventEmitter<{
    active: string;
    direction: "ASC" | "DESC";
  }> = new EventEmitter();

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("sortDetail1") sortDetail1: MatSort;

  private destroy$ = new Subject<void>();

  displayedColumns: string[] = [
    "det",
    "trip",
    "dateTeoric",
    "dateReal",
    "route",
    "weight",
  ]; //'actions'

    isNavOpened: boolean = true;

  selectedItem: TripTableSelectedItem | null = null;

  dataSourceDetail1 = new MatTableDataSource<TripMaterial>([]);

  dialogRefEdit: MatDialogRef<any>;

  editOrderForm: FormGroup;

  routes = signal<SubRouteAttributes[]>([]);
  trips = signal<TripAttributes[]>([]);
  documentClassesLocal = signal<DocumentClassAttributes[]>([]);
  selectedTabIndex = 0;
  documentType = DocumentTypeEnum.DOCUMENTO_DE_CARGA;
  private lastRefreshContext: RefreshContext | null = null;

  // ========== CONSTANTES PARA ÍNDICES DE TABS (evitar números mágicos) ==========
  private readonly TAB_INDEX_SUMMARY_MATERIAL = 0;
  private readonly TAB_INDEX_ORDERS = 1;
  private readonly TAB_INDEX_UNIFIED = 2;

  // ========== VARIABLES DE PAGINACIÓN PARA TAB PEDIDOS ==========
  ordersPageSize: number = 20;           // Pedidos por página
  ordersCurrentPage: number = 1;         // Página actual
  ordersTotalItems: number = 0;          // Total de pedidos

  // ========== VARIABLES DE PAGINACIÓN PARA TAB UNIFICADOS ==========
  unifiedPageSize: number = 20;          // Pedidos unificados por página
  unifiedCurrentPage: number = 1;        // Página actual
  unifiedTotalItems: number = 0;         // Total de pedidos unificados

  unsubscribeAll = new Subject<void>();
  constructor(
    private loadsService: LoadsService,
    private orderListService: OrdersListService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private readonly router: Router,
    private handlerMessage: HandlerMessageService,
    private readonly _fuseNavigationService: FuseNavigationService
  ) {}

  async ngOnInit() {
    this.editOrderForm = this.fb.group({
      route: [""],
      date: [""],
      time: [""],
      trip: [""],
    });

    this.setupNavigationListener();

    if (this.documentClasses && this.documentClasses.length > 0)
      this.documentClassesLocal.update(() => this.documentClasses);
  }

  async ngOnChanges(changes: SimpleChanges) {

    if (changes.documentClasses?.currentValue)
      this.documentClassesLocal.update(
        () => changes.documentClasses.currentValue
      );
  }


  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  OrderUpdate(context?: RefreshContext) {
    if (!this.selectedItem) return;

    this.lastRefreshContext = context || null;

    if (context?.type === 'unify') {
      const currentTab = this.selectedTabIndex;

      if (currentTab === this.TAB_INDEX_ORDERS) {
        this.loadOrdersForSelectedTrip();
      } else if (currentTab === this.TAB_INDEX_UNIFIED) {
        this.loadUnifiedOrdersForSelectedTrip();
      }

      setTimeout(() => {
        this.lastRefreshContext = null;
      }, 100);
    }
  }

  async groupOrdersByTripAndRoute(): Promise<any[]> {
    // Si los datos ya vienen pre-agrupados del backend (getTripsByLoadDocs),
    // retornarlos directamente sin re-agrupar
    if (this.isPreGroupedData()) {
      return this.ordersData.map((trip: any) => ({
        id: `${trip.tripId}-${trip.subRouteExternalCode}`,
        trip: trip.tripId,
        tripMongoId: trip.tripMongoId,
        route: {
          externalKeys: trip.subRouteExternalCode,
          name: trip.subRouteName,
          model: {} as any,
          type: "" as any,
        },
        tripDateHourEndTeoric: trip.tripDateHourEndTeoric,
        tripDateHourStartTeoric: trip.tripDateHourStartTeoric,
        tripDateHourStart: trip.tripDateHourStart,
        tripDateHourEnd: trip.tripDateHourEnd,
        weight: trip.weight,  // ← Usar weight del backend (number)
        orders: [],           // ← No hay órdenes anidadas
        materialsSummary: [], // ← No hay materiales
        unifiedOrders: [],    // ← No hay órdenes unificadas
      }));
    }

    // Resto del código original para casos donde sí necesitamos agrupar
    const groupedOrders = new Map<
      string,
      {
        id: string;
        trip: OrderTripAttributes;
        route: OrderSubRouteAttributes;
        tripDateHourEndTeoric: string;
        tripDateHourStartTeoric: string;
        tripDateHourStart: string;
        tripDateHourEnd: string;
        weight: string;
        orders: any;
        materialsSummary: any[];
        unifiedOrders: OrderAttributes[];
      }
    >();

    // Ya no necesitamos allUnifiedRequests porque unifiedOrders se cargan lazy
    // const allUnifiedRequests: Promise<void>[] = [];

    this?.ordersData?.forEach((order) => {
      //const key = `${order.trip.externalKeys.code}-${order.subRoute.externalKeys.code}`;
      const key = `${(order as any)?.tripId}-${(order as any)?.subRouteExternalCode}`;

      if (!groupedOrders.has(key)) {
        groupedOrders.set(key, {
          id: key,
          trip: order?.tripId,
          route: {
            externalKeys: order?.subRouteExternalCode,
            name: order?.subRouteName,
            model: {} as any,
            type: "" as any,
          },
          tripDateHourEndTeoric: order?.tripDateHourEndTeoric,
          tripDateHourStartTeoric: order?.tripDateHourStartTeoric,
          tripDateHourStart: order?.tripDateHourStart,
          tripDateHourEnd: order?.tripDateHourEnd,
          weight: this.calculateTotalGlobalWeight(order?.orders ?? []),
          orders: [],
          materialsSummary: [],
          unifiedOrders: [],
        });
      }

      const group = groupedOrders.get(key);

      // Orders ya NO se embeden aquí - se cargarán vía lazy loading cuando el usuario haga click en el tab "Pedidos"
      // group.orders.push(...order?.orders ?? []);

      if (Array.isArray(order?.materials)) {
        order.materials.forEach((detail) => {
          group.materialsSummary.push({
            price: detail?.unitPrice,
            code: detail?.code,
            name: detail?.name,
            baseUnitOfMeasure: detail?.baseUnitOfMeasure,
            pararellUnitOfMeasure: detail?.pararellUnitOfMeasure,
            baseQuantity: detail?.quantities?.requestedBase ?? 0,
            pararellQuantity: detail?.quantities?.requestedPararell ?? 0,
            soldQuantity: detail?.quantities?.requested ?? 0,
            stockConfirmedERP: detail?.quantities?.confirmed ?? null,
            orders: detail?.orders ?? [],
          });
        });
      }

      // NOTA: UnifiedOrders ya NO se cargan aquí de manera EAGER
      // Se cargarán de manera LAZY cuando el usuario haga click en el tab "Unificados"
      // usando loadUnifiedOrdersForSelectedTrip() con filtro operationType=4

      // CÓDIGO ANTERIOR COMENTADO (causaba N+1 HTTP calls):
      // 2. Procesar unifiedOrders asíncronamente // Nueva modificacion para refrescar
      // const filteredOrders = order?.orders?.filter(
      //   (o) => o?.sourceTransactions?.length >= 2
      // );
      // filteredOrders?.forEach((principalOrder) => {
      //   const request = forkJoin(
      //     principalOrder.sourceTransactions.map((transaction) =>
      //       this.getOrder(transaction.serial).pipe(
      //         map((res) => res.data[0] || null),
      //         catchError(() => of(null))
      //       )
      //     )
      //   )
      //     .toPromise()
      //     .then((orderResponses: any[]) => {
      //       const validOrders = orderResponses.filter(Boolean);
      //       group.unifiedOrders.push({
      //         serial: principalOrder.serial,
      //         orders: validOrders,
      //         quantity: validOrders.length,
      //       });
      //     });
      //
      //   allUnifiedRequests.push(request);
      // });
    });

    // Ya no necesitamos esperar allUnifiedRequests porque no se cargan eagerly
    // await Promise.all(allUnifiedRequests);

    this.cdr.detectChanges();
    const result = Array.from(groupedOrders.values());
    return result;
  }

  private calculateTotalGlobalWeight(orders: OrderAttributes[]): string {
    let totalWeight = 0;

    if (!Array.isArray(orders)) return "0.000";

    orders.forEach((order) => {
      totalWeight += parseFloat(
        calculateTotalWeight(order, this.loadCalculationMode)
      );
    });
    return `${totalWeight.toFixed(3)}`;
  }

  private isPreGroupedData(): boolean {
    // Los datos están pre-agrupados si tienen tripId pero NO tienen array 'orders'
    return this.ordersData?.length > 0 &&
           'tripId' in this.ordersData[0] &&
           !('orders' in this.ordersData[0]);
  }

  getOrder(serial: string): Observable<any> {
    return this.loadsService.getOrder(serial);
  }

  private getSortField(sortActive: string): keyof OrderAttributes {
    const sortFieldMapping: Record<string, keyof OrderAttributes> = {
      serial: "serial",
      soldTo: "soldTo",
      shipTo: <any>"shipTo",
      deliveryDateTime: <any>"deliveryDateTime",
      weight: <any>"weight",
    };
    return sortFieldMapping[sortActive] || "deliveryDateTime";
  }

  changeSort(event: { active: string; direction: "asc" | "desc" }) {
    const direction = event.direction === "asc" ? "ASC" : "DESC";
    this.onSortChange.emit({
      active: this.getSortField(event.active),
      direction,
    });
  }

  closeDetails(): void {
    this.selectedItem = null;
  }

  async toggleDetails(item: any): Promise<void> {
    console.log('toggleDetails', item);
    if (this.selectedItem && this.selectedItem?.tripId === item?.tripId) {
      this.closeDetails();
      return;
    }

    this.selectedItem = item;

    // Resetear tab y paginación
    this.selectedTabIndex = this.TAB_INDEX_SUMMARY_MATERIAL;
    this.ordersCurrentPage = 1;
    this.unifiedCurrentPage = 1;

    try {
      // SOLO CARGAR MATERIALES (YA EXISTE)
      // Los orders se cargarán cuando el usuario haga click en el tab "Pedidos"
      if (!this.selectedItem.materialsSummary ||
          this.selectedItem.materialsSummary.length === 0) {
        const materialsResponse = await this.loadsService
          .getMaterialsByTrip(item.tripMongoId, {})
          .toPromise();

        const materials = materialsResponse?.data?.data || [];

        this.selectedItem.materialsSummary = materials.map(material => ({
          ...material,
          baseQuantity: material.quantities?.requestedBase ?? 0,
          pararellQuantity: material.quantities?.requestedPararell ?? 0,
          soldQuantity: 0,
          stockConfirmedERP: material.quantities?.confirmed ?? null,
          orders: material.orders
        } as any));
      }

    } catch (err: any) {
      this.handlerMessage.error({
        message: err?.error?.message,
        alternativeMessage: 'Error al cargar los detalles del trip',
        statusCode: err?.status
      });
    }

    this.dataSourceDetail1.data = this.selectedItem.materialsSummary || [];
    this.dataSourceDetail1.sort = this.sortDetail1;
  }

  updateOrder(item: any): void {
    if (this.selectedItem) {
      this.selectedItem.orders = item;
    }
  }

  updateUnified(item: any): void {
    if (this.selectedItem) {
      this.selectedItem.unifiedOrders = item;
    }
  }

  showEditOrderModal(order: OrderAttributes): void {
    this.editOrderForm.reset();

    let route = order.subRoute ? order.subRoute._id : "";
    let trip = order.trip ? order.trip._id : "";
    let deliveryDateTime = order.deliveryDateTime ?? "";

    // this.setDateTimeFromISOToForm(deliveryDateTime as string);

    this.editOrderForm.patchValue({
      route: route,
      trip: trip,
    });

    this.dialogRefEdit = this.dialog.open(this.editModal, {
      panelClass: "form-modal",
      disableClose: true,
    });
  }

  onCloseEditOrderModal() {
    this.editOrderForm.reset();
    this.dialogRefEdit.close("Close");
  }

  tabChanged(event: any) {
  }

  goToTravel(data: OrderAttributes | { trip: string; tripID: string }) {
    let element : any = data;
    if (element?.trip || element?.tripId) {
      const queryParams = { tripId: element?.trip ?? element?.tripId };
      const urlTree = this.router.createUrlTree(
        ["monitor", "principal-screen"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }

  onSummaryRefresh() {
    // Defensive validation: only change tab if a trip is selected
    if (!this.selectedItem) {
      console.warn('onSummaryRefresh called but no trip is selected (selectedItem is null)');
      return;
    }

    // Set refresh context BEFORE changing tab to protect data from being cleared
    // This prevents validateAndResetSelectedItemAfterFilterChange() from clearing selectedItem.orders/unifiedOrders
    this.lastRefreshContext = {
      type: 'unify',
      metadata: {
        tabIndex: 2
      }
    };

    // Change to "Unificados" tab
    this.selectedTabIndex = 2;

    // Force change detection to ensure tab switches
    this.cdr.detectChanges();

    // Reload unified orders (this will be called again by onTabChange but that's OK)
    this.loadUnifiedOrdersForSelectedTrip();
  }

  /**
   * Lazy loading de pedidos cuando el usuario hace click en el tab "Pedidos"
   */
  async loadOrdersForSelectedTrip(): Promise<void> {
    if (!this.selectedItem) return;

    const ordersOptions: IPagination<OrderAttributes> = {
      currentPage: this.ordersCurrentPage,
      limitPerPage: this.ordersPageSize,
      sort: "creationDateTime",
      sortDirection: "DESC",
      search: "",
    };

    // Construir objeto de filtros para findAllWithCount
    const dataToFilter = {
      type: this.documentType,           // 'DT003' - Documento de carga
      tripId: this.selectedItem.tripId,  // Filtro por trip.id
      status: [1],                       // Solo pedidos activos (statusId=1)
    };

    try {
      const ordersResponse = await this.orderListService
        .findAllWithCount(ordersOptions, dataToFilter)
        .toPromise();

      this.selectedItem.orders = ordersResponse?.data?.data || [];
      this.ordersTotalItems = ordersResponse?.data?.pageInfo?.[0]?.total || 0;
    } catch (err: any) {
      this.handlerMessage.error({
        message: err?.error?.message,
        alternativeMessage: 'Error al cargar los pedidos del viaje',
        statusCode: err?.status
      });
    }
  }

  /**
   * Lazy loading de pedidos unificados cuando el usuario hace click en el tab "Unificados"
   */
  async loadUnifiedOrdersForSelectedTrip(): Promise<void> {
    if (!this.selectedItem) return;

    const unifiedOptions: IPagination<OrderAttributes> = {
      currentPage: this.unifiedCurrentPage,
      limitPerPage: this.unifiedPageSize,
      sort: "creationDateTime",
      sortDirection: "DESC",
      search: "",
    };

    // Construir objeto de filtros para findAllWithCount
    const dataToFilter = {
      type: this.documentType,           // 'DT003' - Documento de carga
      tripId: this.selectedItem.tripId,  // Filtro por trip.id
      status: [1],                       // Solo pedidos activos (statusId=1)
      operationType: 4,                  // Solo pedidos unificados (operationType=4)
    };

    try {
      const unifiedResponse = await this.orderListService
        .findAllWithCount(unifiedOptions, dataToFilter)
        .toPromise();

      this.selectedItem.unifiedOrders = unifiedResponse?.data?.data || [];
      this.unifiedTotalItems = unifiedResponse?.data?.pageInfo?.[0]?.total || 0;

      // Clear refresh context after successful load
      if (this.lastRefreshContext?.type === 'unify') {
        this.lastRefreshContext = null;
      }
    } catch (err: any) {
      this.handlerMessage.error({
        message: err?.error?.message,
        alternativeMessage: 'Error al cargar los pedidos unificados del viaje',
        statusCode: err?.status
      });

      // Clear context even on error to prevent stale state
      if (this.lastRefreshContext?.type === 'unify') {
        this.lastRefreshContext = null;
      }
    }
  }

  /**
   * Carga bajo demanda los sourceTransactions cuando el usuario expande un pedido unificado
   * Optimizado: usa 1 sola llamada HTTP batch en lugar de N llamadas individuales
   */
  async loadSourceTransactions(unifiedOrder: OrderAttributes): Promise<void> {
    // Si ya están cargados, no hacer nada
    if ((unifiedOrder as any)._sourceTransactionsLoaded) return;

    // Si no hay sourceTransactions, marcar como cargado y salir
    if (!unifiedOrder.sourceTransactions || unifiedOrder.sourceTransactions.length === 0) {
      (unifiedOrder as any)._sourceTransactionsLoaded = true;
      return;
    }

    try {
      // ✅ EXTRAER TODOS LOS SERIALS (batch loading)
      const serials = unifiedOrder.sourceTransactions.map(st => st.serial);

      // ✅ CONSTRUIR FILTROS PARA BATCH LOADING
      const dataToFilter = {
        ordersToFilter: serials,    // Reutilizar filtro existente (filtra por serial)
        status: [1],                // Solo pedidos activos
      };

      // Opciones de paginación (traer todos los sourceTransactions)
      const options: IPagination<OrderAttributes> = {
        currentPage: 1,
        limitPerPage: serials.length,  // Limitar al número exacto
        sort: 'creationDateTime',
        sortDirection: 'DESC',
        search: '',  // ⚠️ IMPORTANTE: search vacío para que ordersToFilter funcione
      };

      // ✅ 1 SOLA LLAMADA HTTP CON BATCH LOADING
      const response = await this.orderListService
        .findAllWithCount(options, dataToFilter)
        .toPromise();

      const loadedOrders = response?.data?.data || [];

      // Crear mapa para búsqueda rápida y mantener orden original
      const ordersMap = new Map<string, OrderAttributes>();
      loadedOrders.forEach(order => {
        ordersMap.set(order.serial, order);
      });

      // Reemplazar sourceTransactions con datos completos, manteniendo orden
      unifiedOrder.sourceTransactions = unifiedOrder.sourceTransactions
        .map(st => ordersMap.get(st.serial))
        .filter(order => order !== undefined) as any[];

      // Marcar como cargado
      (unifiedOrder as any)._sourceTransactionsLoaded = true;
    } catch (err: any) {
      this.handlerMessage.error({
        message: err?.error?.message,
        alternativeMessage: 'Error al cargar los detalles de los pedidos origen',
        statusCode: err?.status
      });
    }
  }

  /**
   * Carga TODOS los sourceTransactions de los pedidos unificados de golpe
   * Se llama cuando se abre el tab "Unificados" para tener datos completos
   */
  private async loadAllSourceTransactionsForUnifiedOrders(): Promise<void> {
    if (!this.selectedItem?.unifiedOrders ||
        this.selectedItem?.unifiedOrders.length === 0) {
      return;
    }

    const allSerials = this.selectedItem?.unifiedOrders
      .flatMap(order => order.sourceTransactions?.map(st => st.serial) || []);

    if (allSerials.length === 0) return;

    try {
      const dataToFilter = {
        ordersToFilter: allSerials,
        status: [1],
      };

      const options: IPagination<OrderAttributes> = {
        currentPage: 1,
        limitPerPage: allSerials.length,
        sort: 'creationDateTime',
        sortDirection: 'DESC',
        search: '',
      };

      const response = await this.orderListService
        .findAllWithCount(options, dataToFilter)
        .toPromise();

      const loadedOrders = response?.data?.data || [];

      const ordersMap = new Map<string, OrderAttributes>();
      loadedOrders.forEach(order => {
        ordersMap.set(order.serial, order);
      });

      this.selectedItem?.unifiedOrders.forEach(unifiedOrder => {
        if (unifiedOrder.sourceTransactions && unifiedOrder.sourceTransactions.length > 0) {
          unifiedOrder.sourceTransactions = unifiedOrder.sourceTransactions
            .map(st => ordersMap.get(st.serial))
            .filter(order => order !== undefined) as any[];

          (unifiedOrder as any)._sourceTransactionsLoaded = true;

          (unifiedOrder as any).quantity = unifiedOrder.sourceTransactions.length;
          (unifiedOrder as any).weight = this.calculateUnifiedWeight(
            unifiedOrder.sourceTransactions as any[]
          );
        }
      });

    } catch (err: any) {
      this.handlerMessage.error({
        message: err?.error?.message,
        alternativeMessage: 'Error al cargar los detalles de pedidos unificados',
        statusCode: err?.status
      });
    }
  }

  /**
   * Calcula el peso total de un array de sourceTransactions
   */
  private calculateUnifiedWeight(orders: OrderAttributes[]): string {
    let totalWeight = 0;

    if (!Array.isArray(orders)) return '0.000';

    orders.forEach(order => {
      totalWeight += parseFloat(calculateTotalWeight(order, this.loadCalculationMode));
    });

    return `${totalWeight.toFixed(3)}`;
  }

  /**
   * Detecta cambio de tab y carga orders cuando se selecciona el tab "Pedidos"
   */
  async onTabChange(tabIndex: number): Promise<void> {
    // Tab "Pedidos" - Lazy loading de orders
    if (tabIndex === this.TAB_INDEX_ORDERS && this.selectedItem) {
      // Cargar orders solo si no están cargados
      if (!this.selectedItem.orders || this.selectedItem.orders.length === 0) {
        await this.loadOrdersForSelectedTrip();
      }
    }

    // Tab "Unificados" - Lazy loading de unifiedOrders
    if (tabIndex === this.TAB_INDEX_UNIFIED && this.selectedItem) {
      // Only load if not already being loaded by onSummaryRefresh
      if (this.lastRefreshContext?.type !== 'unify') {
        // Cargar unifiedOrders solo si no están cargados
        if (!this.selectedItem?.unifiedOrders || this.selectedItem?.unifiedOrders?.length === 0) {
          await this.loadUnifiedOrdersForSelectedTrip();
        }
      }

      // Cargar TODOS los sourceTransactions para poder mostrar columnas (with additional null safety)
      if (this.selectedItem?.unifiedOrders && Array.isArray(this.selectedItem?.unifiedOrders)) {
        const needsSourceTransactions = this.selectedItem.unifiedOrders.some(
          order => !(order as any)._sourceTransactionsLoaded
        );

        if (needsSourceTransactions) {
          await this.loadAllSourceTransactionsForUnifiedOrders();
          // Trigger change detection in unified-table component to recalculate #PEDIDOS and CARGA columns
          this.updateUnified(this.selectedItem.unifiedOrders);
        }
      }
    }
  }

  /**
   * Event handler para cambio de página en el paginador de pedidos
   */
  onOrdersPageChange(event: PageEvent): void {
    this.ordersCurrentPage = event.pageIndex + 1;
    this.ordersPageSize = event.pageSize;
    this.loadOrdersForSelectedTrip();
  }

  /**
   * Event handler para cambio de página en el paginador de pedidos unificados
   */
  onUnifiedPageChange(event: PageEvent): void {
    this.unifiedCurrentPage = event.pageIndex + 1;
    this.unifiedPageSize = event.pageSize;
    this.loadUnifiedOrdersForSelectedTrip();
  }

  /**
   * Event handler para cuando el usuario expande un pedido unificado
   * Carga los sourceTransactions bajo demanda
   */
  onExpandUnified(unifiedOrder: OrderAttributes): void {
    this.loadSourceTransactions(unifiedOrder);
  }

  //#region Map
  openModal(element): void {
    const data: MapModalInputData = {
      type: MapModalTypeEnum.GROUPED_WITH_FILTER,
      useDate: false,
      tripId: element.trip,
      element: element,
      document: MonitorDocumentTypeEnum.DOCUMENT,
      groupDocuments: [],
      map: {
        displayMode: 'drawer',
        captions: { title: 'Ubicación' }
      },
      filters:{
        mode: MapFilterTypeEnum.NORMAL,
        filters: {
          statusIds: [StatusEnum.ACTIVE],
        }
      }
    }

    this.openMap(data)
  }
  
  openMap(data) {
    this.dialog.open(MapModalComponent, {
      width: '90%',
      //height: '80%',
      data: data
    });
  }
  //#endregion

  /**
   * Abre el orden de visita del viaje de `element` — ver
   * fs-98-trip-visit-order-editor. Mismo tamaño/técnica de `panelClass` que
   * `RouteOptimizationSuggestionDialog` (`loads.component.ts`).
   */
  openVisitOrderModal(element: any): void {
    const data: TripVisitOrderDialogData = { tripMongoId: element.tripMongoId };
    this.dialog.open(TripVisitOrderDialog, {
      data,
      width: '95vw',
      maxWidth: '95vw',
      height: '92vh',
      maxHeight: '92vh',
      autoFocus: false,
      panelClass: 'trip-visit-order-modal',
    });
  }

    private setupNavigationListener(): void {
    const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>('mainNavigation');

    if (navigation) {
      // Set initial state
      this.isNavOpened = navigation.opened;

      // Subscribe to changes
      navigation.openedChanged
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe((opened: boolean) => {
          this.isNavOpened = opened;
          this.cdr.detectChanges();
        });
    }
  }
}
